var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clone
    ? _c(
        "div",
        { staticClass: "block-editor provider-response" },
        [
          _c("div", { staticClass: "wrapper" }, [
            _vm.openrouterChannels.length > 0
              ? _c(
                  "section",
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("Kanal Seçin (Opsiyonel)"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: _vm.$t("Otomatik kanal seçimi"),
                          allowClear: "",
                        },
                        model: {
                          value: _vm.clone.channelId,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone, "channelId", $$v)
                          },
                          expression: "clone.channelId",
                        },
                      },
                      _vm._l(_vm.openrouterChannels, function (channel) {
                        return _c(
                          "a-select-option",
                          { key: channel._id, attrs: { value: channel._id } },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(channel.name) +
                                "\n                "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("section", [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Model"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "model-input-wrapper" },
                [
                  _c("TiptapEditor", {
                    staticClass: "model-input",
                    attrs: {
                      placeholder: _vm.getModelPlaceholder(),
                      "show-attributes": true,
                      "automation-mode": "",
                    },
                    model: {
                      value: _vm.clone.model,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "model", $$v)
                      },
                      expression: "clone.model",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      attrs: {
                        type: "primary",
                        loading: _vm.loadingModels,
                        disabled: !_vm.selectedChannel,
                      },
                      on: { click: _vm.openModelSelector },
                    },
                    [
                      !_vm.loadingModels
                        ? _c("span", { staticClass: "material-icons" }, [
                            _vm._v("search"),
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Model Seç")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "help-text" }, [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.modelHint))]),
              ]),
            ]),
            _vm._v(" "),
            _c("section", [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("Mesajlar")) +
                      "\n                "
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { size: "small", type: "primary", ghost: "" },
                      on: { click: _vm.addMessage },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "16px" },
                        },
                        [_vm._v("add")]
                      ),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Mesaj Ekle")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "messages-list" },
                _vm._l(_vm.clone.messages, function (msg, index) {
                  return _c(
                    "div",
                    { key: "msg-" + index, staticClass: "message-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "message-header" },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "140px" },
                              model: {
                                value: msg.role,
                                callback: function ($$v) {
                                  _vm.$set(msg, "role", $$v)
                                },
                                expression: "msg.role",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "user" } },
                                [_vm._v("User")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "system" } },
                                [_vm._v("System")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "assistant" } },
                                [_vm._v("Assistant")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "tool" } },
                                [_vm._v("Tool")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "message-actions" },
                            [
                              index > 0
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { size: "small", type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.moveMessage(index, -1)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [_vm._v("arrow_upward")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              index < _vm.clone.messages.length - 1
                                ? _c(
                                    "a-button",
                                    {
                                      attrs: { size: "small", type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.moveMessage(index, 1)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [_vm._v("arrow_downward")]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: {
                                    size: "small",
                                    type: "link",
                                    disabled: _vm.clone.messages.length <= 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeMessage(index)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("delete")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      msg.role === "tool"
                        ? _c(
                            "div",
                            { staticClass: "tool-fields" },
                            [
                              _c("TiptapEditor", {
                                staticClass: "tool-field-input",
                                attrs: {
                                  placeholder: _vm.$t("Tool Call ID"),
                                  "show-attributes": true,
                                  "automation-mode": "",
                                },
                                model: {
                                  value: msg.toolCallId,
                                  callback: function ($$v) {
                                    _vm.$set(msg, "toolCallId", $$v)
                                  },
                                  expression: "msg.toolCallId",
                                },
                              }),
                              _vm._v(" "),
                              _c("TiptapEditor", {
                                staticClass: "tool-field-input",
                                attrs: {
                                  placeholder: _vm.$t("Tool Name"),
                                  "show-attributes": true,
                                  "automation-mode": "",
                                },
                                model: {
                                  value: msg.name,
                                  callback: function ($$v) {
                                    _vm.$set(msg, "name", $$v)
                                  },
                                  expression: "msg.name",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "content-type-section" },
                        [
                          _c(
                            "a-select",
                            {
                              staticStyle: {
                                width: "160px",
                                "margin-bottom": "8px",
                              },
                              attrs: { placeholder: _vm.$t("İçerik Tipi") },
                              on: {
                                change: function ($event) {
                                  return _vm.onContentTypeChange(msg, $event)
                                },
                              },
                              model: {
                                value: msg.contentType,
                                callback: function ($$v) {
                                  _vm.$set(msg, "contentType", $$v)
                                },
                                expression: "msg.contentType",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "text" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "vertical-align": "middle",
                                      },
                                    },
                                    [_vm._v("text_fields")]
                                  ),
                                  _vm._v(
                                    "\n                                Metin\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "image" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "vertical-align": "middle",
                                      },
                                    },
                                    [_vm._v("image")]
                                  ),
                                  _vm._v(
                                    "\n                                Resim (URL)\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "file" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "vertical-align": "middle",
                                      },
                                    },
                                    [_vm._v("attach_file")]
                                  ),
                                  _vm._v(
                                    "\n                                Dosya\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "audio" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "vertical-align": "middle",
                                      },
                                    },
                                    [_vm._v("audiotrack")]
                                  ),
                                  _vm._v(
                                    "\n                                Ses\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "video" } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "material-icons",
                                      staticStyle: {
                                        "font-size": "14px",
                                        "vertical-align": "middle",
                                      },
                                    },
                                    [_vm._v("videocam")]
                                  ),
                                  _vm._v(
                                    "\n                                Video\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !msg.contentType || msg.contentType === "text"
                            ? _c(
                                "div",
                                [
                                  _c("TiptapEditor", {
                                    key:
                                      "msg-content-" +
                                      index +
                                      "-" +
                                      _vm.renderKey,
                                    attrs: {
                                      "show-emoji": true,
                                      "show-attributes": true,
                                      placeholder: _vm.getMessagePlaceholder(
                                        msg.role
                                      ),
                                      "max-character-count": 10000,
                                      "automation-mode": "",
                                    },
                                    model: {
                                      value: msg.content,
                                      callback: function ($$v) {
                                        _vm.$set(msg, "content", $$v)
                                      },
                                      expression: "msg.content",
                                    },
                                  }),
                                ],
                                1
                              )
                            : msg.contentType === "image"
                            ? _c(
                                "div",
                                { staticClass: "media-input" },
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      "show-attributes": true,
                                      placeholder: _vm.$t(
                                        "Resim URL veya Base64 girin"
                                      ),
                                      "automation-mode": "",
                                    },
                                    model: {
                                      value: msg.imageUrl,
                                      callback: function ($$v) {
                                        _vm.$set(msg, "imageUrl", $$v)
                                      },
                                      expression: "msg.imageUrl",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: {
                                        width: "120px",
                                        "margin-top": "8px",
                                      },
                                      model: {
                                        value: msg.imageDetail,
                                        callback: function ($$v) {
                                          _vm.$set(msg, "imageDetail", $$v)
                                        },
                                        expression: "msg.imageDetail",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "auto" } },
                                        [_vm._v("Auto")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "high" } },
                                        [_vm._v("High")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "low" } },
                                        [_vm._v("Low")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : msg.contentType === "file"
                            ? _c(
                                "div",
                                { staticClass: "media-input" },
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      "show-attributes": true,
                                      placeholder: _vm.$t("Dosya URL girin"),
                                      "automation-mode": "",
                                    },
                                    model: {
                                      value: msg.fileUrl,
                                      callback: function ($$v) {
                                        _vm.$set(msg, "fileUrl", $$v)
                                      },
                                      expression: "msg.fileUrl",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("TiptapEditor", {
                                    staticStyle: { "margin-top": "8px" },
                                    attrs: {
                                      "show-attributes": true,
                                      placeholder: _vm.$t(
                                        "Dosya adı (opsiyonel)"
                                      ),
                                      "automation-mode": "",
                                    },
                                    model: {
                                      value: msg.filename,
                                      callback: function ($$v) {
                                        _vm.$set(msg, "filename", $$v)
                                      },
                                      expression: "msg.filename",
                                    },
                                  }),
                                ],
                                1
                              )
                            : msg.contentType === "audio"
                            ? _c(
                                "div",
                                { staticClass: "media-input" },
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      "show-attributes": true,
                                      placeholder: _vm.$t(
                                        "Ses URL veya Base64 girin"
                                      ),
                                      "automation-mode": "",
                                    },
                                    model: {
                                      value: msg.audioUrl,
                                      callback: function ($$v) {
                                        _vm.$set(msg, "audioUrl", $$v)
                                      },
                                      expression: "msg.audioUrl",
                                    },
                                  }),
                                ],
                                1
                              )
                            : msg.contentType === "video"
                            ? _c(
                                "div",
                                { staticClass: "media-input" },
                                [
                                  _c("TiptapEditor", {
                                    attrs: {
                                      "show-attributes": true,
                                      placeholder: _vm.$t("Video URL girin"),
                                      "automation-mode": "",
                                    },
                                    model: {
                                      value: msg.videoUrl,
                                      callback: function ($$v) {
                                        _vm.$set(msg, "videoUrl", $$v)
                                      },
                                      expression: "msg.videoUrl",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("section", [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("Tools / Functions")) +
                      "\n                "
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { size: "small", type: "primary", ghost: "" },
                      on: { click: _vm.addTool },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "material-icons",
                          staticStyle: { "font-size": "16px" },
                        },
                        [_vm._v("add")]
                      ),
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("Tool Ekle")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.clone.tools && _vm.clone.tools.length > 0
                ? _c(
                    "div",
                    { staticClass: "tools-list" },
                    [
                      _vm._l(_vm.clone.tools, function (tool, tIndex) {
                        return _c(
                          "div",
                          { key: "tool-" + tIndex, staticClass: "tool-item" },
                          [
                            _c(
                              "div",
                              { staticClass: "tool-header" },
                              [
                                _c("span", { staticClass: "tool-badge" }, [
                                  _vm._v("function"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tool-name-wrapper" },
                                  [
                                    _c("label", [
                                      _vm._v(_vm._s(_vm.$t("Fonksiyon Adı"))),
                                    ]),
                                    _vm._v(" "),
                                    _c("a-input", {
                                      attrs: {
                                        placeholder: _vm.$t("get_weather"),
                                      },
                                      model: {
                                        value: tool.function.name,
                                        callback: function ($$v) {
                                          _vm.$set(tool.function, "name", $$v)
                                        },
                                        expression: "tool.function.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      size: "small",
                                      type: "link",
                                      danger: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeTool(tIndex)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("delete")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "tool-description-wrapper" },
                              [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("Açıklama"))),
                                ]),
                                _vm._v(" "),
                                _c("TiptapEditor", {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "Bu fonksiyon ne yapar?"
                                    ),
                                    "show-attributes": true,
                                    "automation-mode": "",
                                  },
                                  model: {
                                    value: tool.function.description,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        tool.function,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression: "tool.function.description",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "tool-parameters" }, [
                              _c(
                                "div",
                                { staticClass: "parameters-header" },
                                [
                                  _c("label", [
                                    _vm._v(_vm._s(_vm.$t("Parametreler"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { size: "small", type: "dashed" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addToolParameter(tool)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "material-icons",
                                          staticStyle: { "font-size": "14px" },
                                        },
                                        [_vm._v("add")]
                                      ),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(_vm.$t("Parametre Ekle")) +
                                          "\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              tool.function.parameters &&
                              tool.function.parameters.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "parameters-list" },
                                    _vm._l(
                                      tool.function.parameters,
                                      function (param, pIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key:
                                              "param-" + tIndex + "-" + pIndex,
                                            staticClass: "parameter-item",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "param-field type-field",
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(_vm._s(_vm.$t("Tip"))),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select",
                                                  {
                                                    staticStyle: {
                                                      width: "100%",
                                                    },
                                                    model: {
                                                      value: param.type,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          param,
                                                          "type",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "param.type",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a-select-option",
                                                      {
                                                        attrs: {
                                                          value: "string",
                                                        },
                                                      },
                                                      [_vm._v("String")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-select-option",
                                                      {
                                                        attrs: {
                                                          value: "number",
                                                        },
                                                      },
                                                      [_vm._v("Number")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-select-option",
                                                      {
                                                        attrs: {
                                                          value: "boolean",
                                                        },
                                                      },
                                                      [_vm._v("Boolean")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-select-option",
                                                      {
                                                        attrs: {
                                                          value: "array",
                                                        },
                                                      },
                                                      [_vm._v("Array")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-select-option",
                                                      {
                                                        attrs: {
                                                          value: "object",
                                                        },
                                                      },
                                                      [_vm._v("Object")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "param-field name-field",
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("İsim"))
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder:
                                                      _vm.$t("param_name"),
                                                  },
                                                  model: {
                                                    value: param.name,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        param,
                                                        "name",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "param.name",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "param-field description-field",
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("Açıklama"))
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("a-input", {
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "Parametre açıklaması"
                                                    ),
                                                  },
                                                  model: {
                                                    value: param.description,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        param,
                                                        "description",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "param.description",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "param-field required-field",
                                              },
                                              [
                                                _c("label", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("Zorunlu"))
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("a-switch", {
                                                  attrs: { size: "small" },
                                                  model: {
                                                    value: param.required,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        param,
                                                        "required",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "param.required",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-button",
                                              {
                                                staticClass: "delete-param-btn",
                                                attrs: {
                                                  size: "small",
                                                  type: "link",
                                                  danger: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeToolParameter(
                                                      tool,
                                                      pIndex
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [_vm._v("delete")]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _c("div", { staticClass: "no-parameters" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Henüz parametre eklenmedi")
                                        )
                                      ),
                                    ]),
                                  ]),
                            ]),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "tool-choice-section" },
                        [
                          _c("label", [_vm._v(_vm._s(_vm.$t("Tool Choice")))]),
                          _vm._v(" "),
                          _c(
                            "a-select",
                            {
                              staticStyle: { width: "100%" },
                              model: {
                                value: _vm.clone.tool_choice,
                                callback: function ($$v) {
                                  _vm.$set(_vm.clone, "tool_choice", $$v)
                                },
                                expression: "clone.tool_choice",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "auto" } },
                                [_vm._v("Auto")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "none" } },
                                [_vm._v("None")]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "required" } },
                                [_vm._v("Required")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _c("div", { staticClass: "empty-tools" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("build"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("Henüz tool eklenmedi"))),
                    ]),
                  ]),
            ]),
            _vm._v(" "),
            _c("section", [
              _c(
                "div",
                { staticClass: "title" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("Structured Output (Opsiyonel)")) +
                      "\n                "
                  ),
                  _c("a-switch", {
                    attrs: { size: "small" },
                    model: {
                      value: _vm.clone.useStructuredOutput,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "useStructuredOutput", $$v)
                      },
                      expression: "clone.useStructuredOutput",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.clone.useStructuredOutput
                ? _c(
                    "div",
                    { staticClass: "structured-output-section" },
                    [
                      _c("TiptapEditor", {
                        staticClass: "schema-name-input",
                        attrs: {
                          placeholder: _vm.$t(
                            "Schema adı (örn: weather, user_info)"
                          ),
                          "show-attributes": true,
                          "automation-mode": "",
                        },
                        model: {
                          value: _vm.clone.structuredOutput.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.clone.structuredOutput, "name", $$v)
                          },
                          expression: "clone.structuredOutput.name",
                        },
                      }),
                      _vm._v(" "),
                      _c("a-textarea", {
                        staticClass: "schema-json-input",
                        attrs: {
                          placeholder: _vm.schemaJsonPlaceholder,
                          "auto-size": { minRows: 4, maxRows: 12 },
                        },
                        model: {
                          value: _vm.clone.structuredOutput.schemaJson,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.clone.structuredOutput,
                              "schemaJson",
                              $$v
                            )
                          },
                          expression: "clone.structuredOutput.schemaJson",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "strict-mode" },
                        [
                          _c(
                            "a-checkbox",
                            {
                              model: {
                                value: _vm.clone.structuredOutput.strict,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.clone.structuredOutput,
                                    "strict",
                                    $$v
                                  )
                                },
                                expression: "clone.structuredOutput.strict",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("Strict Mode")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("section", [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.$t("Parametreler"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "params-grid" }, [
                _c(
                  "div",
                  { staticClass: "param-item" },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Temperature")) +
                          "\n                        "
                      ),
                      _c("span", { staticClass: "param-value" }, [
                        _vm._v(_vm._s(_vm.clone.temperature)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-slider", {
                      attrs: { min: 0, max: 2, step: 0.1 },
                      model: {
                        value: _vm.clone.temperature,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "temperature", $$v)
                        },
                        expression: "clone.temperature",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "param-item" },
                  [
                    _c("label", [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("Top P")) +
                          "\n                        "
                      ),
                      _c("span", { staticClass: "param-value" }, [
                        _vm._v(_vm._s(_vm.clone.top_p)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("a-slider", {
                      attrs: { min: 0, max: 1, step: 0.05 },
                      model: {
                        value: _vm.clone.top_p,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "top_p", $$v)
                        },
                        expression: "clone.top_p",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "param-item full-width" },
                  [
                    _c("label", [_vm._v(_vm._s(_vm.$t("Max Tokens")))]),
                    _vm._v(" "),
                    _c("a-input-number", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        min: 1,
                        max: 128000,
                        placeholder: _vm.$t("Varsayılan: Model limiti"),
                      },
                      model: {
                        value: _vm.clone.maxTokens,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "maxTokens", $$v)
                        },
                        expression: "clone.maxTokens",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "a-modal",
            {
              attrs: {
                title: _vm.modelModalTitle,
                width: "900px",
                footer: null,
              },
              model: {
                value: _vm.modelSelectorVisible,
                callback: function ($$v) {
                  _vm.modelSelectorVisible = $$v
                },
                expression: "modelSelectorVisible",
              },
            },
            [
              _c(
                "div",
                { staticClass: "model-selector-modal" },
                [
                  _c(
                    "div",
                    { staticClass: "models-info" },
                    [
                      _c("a-tag", { attrs: { color: "purple" } }, [
                        _vm._v(_vm._s(_vm.providerLabel)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "models-count" }, [
                        _vm._v(
                          _vm._s(_vm.openRouterModels.length) + " model bulundu"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("a-input-search", {
                    staticStyle: { "margin-bottom": "16px" },
                    attrs: { placeholder: _vm.$t("Model ara...") },
                    model: {
                      value: _vm.modelSearchQuery,
                      callback: function ($$v) {
                        _vm.modelSearchQuery = $$v
                      },
                      expression: "modelSearchQuery",
                    },
                  }),
                  _vm._v(" "),
                  _c("a-table", {
                    attrs: {
                      columns: _vm.modelColumns,
                      "data-source": _vm.filteredModels,
                      pagination: { pageSize: 10 },
                      scroll: { y: 400 },
                      size: "small",
                      "row-key": "id",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "action",
                          fn: function (text, record) {
                            return [
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectModel(record)
                                    },
                                  },
                                },
                                [
                                  _c("a-icon", { attrs: { type: "check" } }),
                                  _vm._v(" Seç\n                    "),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1771413465
                    ),
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "help-text" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Structured output, modelin yanıtını belirli bir JSON Schema formatında döndürmesini zorunlu\n                        kılar."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }